import type { ComponentConfig } from "@puckeditor/core"
import { SectionBase, sectionStyle } from "../lib/section"

export type FAQItem = { question: string; answer: string }

export type FAQProps = SectionBase & {
  eyebrow: string
  title: string
  items: FAQItem[]
}

export const FAQ: ComponentConfig<FAQProps> = {
  fields: {
    eyebrow: { type: "text", label: "Eyebrow", contentEditable: true },
    title: { type: "textarea", contentEditable: true },
    items: {
      type: "array",
      arrayFields: {
        question: { type: "text", contentEditable: true },
        answer: { type: "textarea", contentEditable: true },
      },
      defaultItemProps: { question: "New question", answer: "The answer goes here." },
      getItemSummary: (item) => item?.question || "Question",
    },
    background: {
      type: "radio",
      options: [
        { value: "none", label: "Transparent" },
        { value: "muted", label: "Muted" },
        { value: "accent", label: "Dark" },
      ],
    },
    paddingY: {
      type: "radio",
      options: [
        { value: "none", label: "None" },
        { value: "sm", label: "Small" },
        { value: "md", label: "Medium" },
        { value: "lg", label: "Large" },
      ],
    },
  },

  defaultProps: {
    eyebrow: "",
    title: "Frequently asked questions",
    items: [],
    background: "none",
    paddingY: "lg",
  },

  render: ({ eyebrow, title, items, background, paddingY }) => {
    const s = sectionStyle({ background, paddingY })

    return (
      <section style={s}>
        <div style={{ maxWidth: 800, margin: "0 auto", padding: "0 24px" }}>
          <div style={{ textAlign: "center", marginBottom: 40 }}>
            {eyebrow && (
              <p style={{ fontSize: 13, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--site-accent, #7c3aed)", marginBottom: 12 }}>
                {eyebrow}
              </p>
            )}
            <h2 style={{ fontSize: "clamp(1.75rem,4vw,2.5rem)", fontWeight: 800 }}>{title}</h2>
          </div>
          {items.length > 0 && (
            <div>
              {items.map((item, i) => (
                <details key={i} style={{ borderBottom: "1px solid #e5e7eb", padding: "16px 0" }}>
                  <summary style={{ fontWeight: 600, fontSize: "1rem", cursor: "pointer" }}>{item.question}</summary>
                  <p style={{ marginTop: 12, color: "#6b7280", lineHeight: 1.7 }}>{item.answer}</p>
                </details>
              ))}
            </div>
          )}
        </div>
      </section>
    )
  },
}
